import React from "react";
import { PropListItem, PropLabel } from "./styles";

const GenericElement = ({ label, currentValue, locale, ...props }) => {
  return (
    <PropListItem>
      <PropLabel>{label[locale]}</PropLabel>
      {currentValue}
    </PropListItem>
  );
};

export default GenericElement;
